import React from 'react';
import GoogleMapReact from 'google-map-react';
import mapStyles from '../../../assets/config/map'
import HomeMapMarker from "./marker"
export class HomeMap extends React.Component {
    static defaultProps = {
        center: { lat: 44.4300, lng: 26.1025 },
        zoom: 14,
        options: {
            scrollwheel: false,
            styles: mapStyles
        },
        key: "AIzaSyDRZj46wVpLYdD4-eNKUUJadb43WFko5gU"
    };
    render() {
        return (
            <div className="map-wrapper">
                <GoogleMapReact
                    bootstrapURLKeys={{
                        key: this.props.key
                    }}
                    defaultCenter={this.props.center}
                    defaultZoom={this.props.zoom}
                    options={this.props.options}
                >
                    <HomeMapMarker lat="44.4268"
                        lng={this.props.center.lng}
                        text={'Adrian'} ></HomeMapMarker>
                </GoogleMapReact>
                <div className="map-overlay"></div>
            </div>
        );
    }
}


export default HomeMap;



// WEBPACK FOOTER //
// ./src/components/home/Map/index.js